import { InjectionToken } from '@angular/core';
import { SessionConfig } from './session.types';
import { AuthClient } from '../auth/auth-client';

export const SESSION_CONFIG = new InjectionToken<SessionConfig>('SESSION_CONFIG');
export const AUTH_CLIENT = new InjectionToken<AuthClient>('AUTH_CLIENT');
